import { createFileRoute } from "@tanstack/react-router";
import SaintVsTraditionalTmsGoogle from "@/pages/SaintVsTraditionalTmsGoogle";
export const Route = createFileRoute("/saint-vs-traditional-tms-google")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title: "SAINT® vs Traditional TMS | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SAINT® vs traditional TMS: compare 5-day accelerated fMRI-guided treatment to 6-week standard TMS for depression in Coral Springs, FL. Free consultation.",
        },
        {
          property: "og:title",
          content: "SAINT® vs Traditional TMS | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SAINT® vs traditional TMS: compare 5-day accelerated fMRI-guided treatment to 6-week standard TMS for depression in Coral Springs, FL. Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/saint-vs-traditional-tms-google",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-vs-traditional-tms-google",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintVsTraditionalTmsGoogle />;
}
